module.exports = "/images/ny-life2-12.jpg";